const AuthLogin = () => import(/* webpackPrefetch: true, webpackChunkName: "add-pet" */ '@/app/views/auth-view/components/auth-login/auth-login.vue');
const AuthRegisterContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-register-continer" */ '@/app/views/auth-view/components/auth-register/containers/auth-register-container/auth-register-container.vue');
const AuthForgotPass = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-forgot-password" */ '@/app/views/auth-view/components/auth-forgot-password/auth-forgot-password.vue');
const AuthSetPass = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-set-password" */ '@/app/views/auth-view/components/auth-set-password/auth-set-password.vue');

export default {
    name: 'AuthContainer',
    components: {
        AuthLogin,
        AuthRegisterContainer,
        AuthForgotPass,
        AuthSetPass
    },
    data() {
        return {
            headerText: 'Welcome'
        }
    },
    computed: {
        selectedRoute(){
            let selectedComponent = '';
            switch(this.$route.path) {
                case '/register': 
                    selectedComponent = 'auth-register-container';
                    break;
                case '/create-account': 
                    selectedComponent = 'auth-register-container';
                    break;
                case '/forgot':
                    selectedComponent = 'auth-forgot-pass';
                    break;

                case '/reset-password':
                case '/set-password':
                    selectedComponent = 'auth-set-pass';
                    break;
                
                default: 
                    selectedComponent = 'auth-login'
            }

            return selectedComponent;
        }
    },
    watch: {
    '$route':{
        immediate: true,
        handler(uri){
            switch(uri.path) {
                case '/forgot':
                    // Clears Auth Status Message when navigating.
                    this.$store.dispatch('setPassMessage');

                    this.headerText = 'Forgot Password';
                    break;

                case '/reset-password':
                    this.headerText = 'Reset Password';
                    break;

                case '/set-password':
                    this.headerText = 'Set Password';
                    break;
                    
                default: 
                    this.headerText = 'Welcome';
            }
        }
    }
    },
    methods: {
        setDesktopHeader(activeComponent) {
            // Clears Auth Status Message when navigating.
            this.$store.dispatch('setPassMessage');

            // set header to either Add Human or Add Pet.
            if(activeComponent === 'add-pet') {
                this.headerText = 'Add your pet';
            } else if (activeComponent === 'select-preferred-breeds') {
                this.headerText = 'Select Preferred Breeds';
            } else {
                this.headerText = 'Add a Human [You]';
            }
        }
    }
}